import MainLayout from "@/components/layout/admin/MainLayout.vue";
import store from "@/store";
import axios from "axios";
import CONFIG from "@/assets/js/config.js";
import { required, maxLength } from "vuelidate/lib/validators";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

const GRADING_SETTING_DESCRIPTION_MAX = 1000;

export default {
  name: "GradingSettingEdit",
  components: {
    MainLayout,
    Loading,
  },

  data() {
    return {
      isLoading: false,
      submitted: false,
      disabled: false,
      hasData: false,
      noDataMsg: CONFIG.NO_DATA_EXIST,
      campus_name: store.state.user.campus_master.campus_name,
      settingData: {
        name: "",
        description: "",
        login_id: store.state.user.id,
        is_default: false,
      },
    };
  },

  validations: {
    settingData: {
      name: {
        required,
        maxLength: maxLength(255),
      },
      description: {
        maxLength: maxLength(GRADING_SETTING_DESCRIPTION_MAX),
      },
    },
  },

  methods: {
    getDetail() {
      this.isLoading = true;
      this.hasData = false;
      axios
        .get("gradingSetting/detail/" + this.$route.params.id)
        .then((res) => {
          const setting = res.data && res.data.success ? res.data.data : null;
          if (setting && setting.id) {
            if (setting.is_default) {
              this.isLoading = false;
              this.$notification.error("The default grading setting cannot be edited.", {
                timer: 3,
                position: "bottomCenter",
              });
              this.$router.push({
                name: "gradingSettingDetail",
                params: { id: this.$route.params.id },
              });
              return;
            }
            this.settingData.name = setting.name;
            this.settingData.description = setting.description || "";
            this.settingData.is_default = setting.is_default;
            if (setting.campus && setting.campus.campus_name) {
              this.campus_name = setting.campus.campus_name;
            }
            this.hasData = true;
          }
          this.isLoading = false;
        })
        .catch((error) => {
          if (error.response && error.response.status == 401) {
            this.$store.commit("logout");
            window.location.replace("login");
          }
          this.isLoading = false;
        });
    },

    update() {
      this.submitted = true;
      if (this.$v.$invalid) {
        return;
      }
      this.disabled = true;
      this.isLoading = true;
      axios
        .post("gradingSetting/update/" + this.$route.params.id, this.settingData)
        .then((res) => {
          if (res.data.success == true) {
            this.$notification.success("Grading Setting Updated Successfully", {
              timer: 3,
              position: "bottomCenter",
            });
            this.$router.push({ name: "gradingSettingList" });
          } else {
            this.$notification.error(res.data.message || "Update failed", {
              timer: 3,
              position: "bottomCenter",
            });
            this.disabled = false;
            this.isLoading = false;
          }
        })
        .catch((error) => {
          if (error.response && error.response.status == 401) {
            this.$store.commit("logout");
            window.location.replace("login");
          }
          const msg = error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : "Update failed";
          this.$notification.error(msg, {
            timer: 3,
            position: "bottomCenter",
          });
          this.disabled = false;
          this.isLoading = false;
        });
    },

    showList() {
      this.$router.push({ name: "gradingSettingList" });
    },
  },

  mounted() {
    this.getDetail();
  },
};
